export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Ghost = 'ghost',
  Badge = 'badge',
}

export enum ButtonSize {
  XSmall = 'x-small',
  Small = 'small',
  Large = 'large',
}

export const ButtonSizePx = {
  XSmall: 24, // 24px
  Small: 28, // 28px
  Large: 32, // 32px
}
